import bumpMap from "../snippets/bumpMap";
import phongLightingWithRimLight from "../snippets/phongLightingWithRimLight";

export default `
precision highp float;

varying vec2 vTextureCoord;
uniform sampler2D uSampler;

uniform sampler2D depthTexture;
uniform vec2 texelSize;
uniform vec3 uMembraneColor;
uniform float uMembraneAlpha;
uniform vec3 uAlternateMembraneColor;
uniform float uAlternateMembraneAlpha;

${bumpMap('depthTexture', '0.05')}
${phongLightingWithRimLight()}

void main() {
	vec2 vUv = vTextureCoord;
	vec4 depth4 = texture2D(depthTexture, vUv);

	if (depth4.r == 0.0) {
		gl_FragColor = vec4(texture2D(uSampler, vUv).rgb, 1.0);
		return;
	}
	float depth = depth4.r;
	bool useAlternateMembraneColor = depth4.b > 0.9;
	bool useBloodMembrane = !useAlternateMembraneColor && depth4.b > 0.3;

	vec3 membraneColor = useAlternateMembraneColor ? uAlternateMembraneColor : uMembraneColor;
	float membraneAlpha = useAlternateMembraneColor ? uAlternateMembraneAlpha : uMembraneAlpha;
	if(useBloodMembrane) membraneColor = vec3(0.8, 0.0, 0.0);

	//vec4 color = vec4(0.0, 0.0, 0.0, 0.0);
	vec3 color = mix(membraneColor, vec3(1., 1., 1.), 0.2);

	//Bump map normals
	vec3 normal = bumpFromDepth(vUv, depth, 15.0, texelSize.x);

	//Apply deferred lighting
	//normal = normalize(vNormalMatrix * normal);

	//Ambient lighting
	float ambientScaler = 0.40; //TODO: There is def something wrong with these balances/way this works.
	vec3 ambientColor = vec3( ambientScaler ); //TODO: Pass this in

	//Light setup
	vec2 lightPos = vec2(1080., -720.); //was uniform, but override to get around bug
	vec3 lightPosition = vec3(lightPos, 1000.); //need a z-dimension for the lighting in "pixels"
	
	LightingInfo lighting = phongLighting(vUv, normal, lightPosition, vec4(color, 1.0));
	vec3 result = lighting.litColor;

	result = mix(result, vec3(1.0, 1.0, 1.0), lighting.specularLight);

	//Membrane transpanrency effect
	float alpha = 0.0;
	float litness = abs((lighting.diffuseLight + lighting.specularLight) - 0.5) * 2.0;
	alpha = mix(1.0, membraneAlpha, 1.0 - litness);
	alpha = pow(alpha, 2.0); //idk looks a bit cooler

	if(depth == 0.0) alpha = 0.0;

	//Sample the refracted background
	float refractionScale = 0.0095;
	vec2 refractedUV = vUv;
	if(!useBloodMembrane) {
		refractedUV +=(normal.xy * refractionScale); 
	}
	vec4 backgroundColor = texture2D(uSampler, refractedUV);

	//Mix the refracted background color with the lit color according to the transparency effect
	result = mix(backgroundColor.xyz, result, alpha);

	gl_FragColor = vec4(result, 1.0);
	//gl_FragColor = color;
}`;